import { Platform, StyleSheet } from 'react-native';

import { smallPaddingBox } from '../view-style';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    ...smallPaddingBox,
  },
  progressBarContainer: {
    flex: 1,
  },
  playerButton: {
    paddingRight: 15,
  },
  timeContainer: {
    flex: 1,
    marginTop: Platform.select({
      web: 2,
      default: 0,
    }),
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  slowButton: {
    paddingLeft: 15,
  },
});
